import PropTypes from 'prop-types';
import React from 'react';
import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import ProjectStatusList from './StatusList';
import { Link, Tooltip } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const TableViewContainer = styled(Paper)(({ theme }) => ({
    width: '100%',
    overflowX: 'auto',
    '& .VL-ProjectRow': {
        borderBottom: `2px solid ${theme.dividers.contentDivider.backgroundColor}`,
        '&:last-child': {
            border: 'none'
        }
    }
}));

const ProjectRow = ({ project, companyId }) => {
    const theme = useTheme();

    return (
        <div className="VL-ProjectRow" style={{ display: 'flex', alignItems: 'center', padding: 16 }}>
            <div style={{ flexGrow: 1, display: 'flex' }}>
                <div>
                    <Link
                        to={`/company/${companyId}/project/${project.id}/activities`}
                        color="primary"
                        component={RouterLink}
                        variant="subtitle1"
                        underline="hover"
                        style={{ ...theme.typography.primaryItemLink }}
                    >
                        { project.name }
                    </Link>
                    <Typography variant="subtitle2">{ project.client }</Typography>
                </div>

                { project.description &&
                    <div style={{ marginLeft: 8 }}>
                        <Tooltip title={project.description ?? ''} placement="top" arrow>
                            <InfoOutlinedIcon
                                sx={{
                                    fill: 'grey.8',
                                    '&:hover': {
                                        fill: 'grey.6'
                                    }
                                }}
                            />
                        </Tooltip>
                    </div>
                }
            </div>
            <ProjectStatusList project={project} style={{ marginLeft: 8 }} />
        </div>
    );
};

ProjectRow.propTypes = {
    companyId: PropTypes.string,
    project: PropTypes.object
};

const ProjectsTableView = ({ projects, companyId }) => {
    return (
        <TableViewContainer variant="outlined">
            { projects.map((project) => (
                <ProjectRow
                    key={`project-row-${project.id}`}
                    companyId={companyId}
                    project={project} />
            ))}
        </TableViewContainer>
    );
};

ProjectsTableView.propTypes = {
    companyId: PropTypes.any,
    projects: PropTypes.array
};

export default ProjectsTableView;
